import Modal from "react-modal";

export default function Popup(props) {

    Modal.setAppElement("body");

    return (
        <Modal isOpen={props.isOpen}
            overlayClassName="compare-popup-overlay"
            className="compare-popup-content"
            onRequestClose={props.onRequestClose}>

            <a className="compare-popup-close" onClick={props.onRequestClose} />

            <div>{props.children}</div>
        </Modal>
    );

};